module.exports = __webpack_public_path__ + "img/espanol.26f619eb.svg";